import Vue from 'vue';
import VueSimpleSpinner from 'vue-simple-spinner';
import HttpMixin from '@/mixins/HttpMixin';
import InvoicesEventHub from '@/components/invoices/InvoicesEventHub';

export default Vue.component('invoice-week-providers', {
  name: 'InvoiceWeekProviders',
  props: {
    'invoiceId': { type: Number, required: false },
    'payableDueDate': { type: String, required: false },
    'isOpen': { type: Boolean, required: true },
    'facilityId': { type: Number, required: false},
    'invoiceWeeks': { type: Array, required: false},
    'invoiceStartDate': { type: Date, required: false}
  },
  components: {
    VueSimpleSpinner,
    InvoicesEventHub
  },
  mixins: [ HttpMixin ],
  data () {
    return {
      providers: []
    };
  },
  watch: {
    async isOpen(newVal: boolean) {
      if (newVal) {
        await this.getProviders();
      }
    }
  },
  computed: {
    canRemoveAtLeastOne(): boolean {
      return this.providers.some((provider: any) => provider.isInQueue);
    },
    canAddAtLeastOne(): boolean {
      return Number(this.invoiceId) > 0 &&
        this.providers.some((provider: any) => !provider.paidDate && !provider.isInQueue && provider.payableTotal > 0);
    }
  },
  methods: {
    async getProviders() {
      let data;
      if (Number(this.invoiceId) > 0) {
        data = await (this as any).httpGet('/invoices/' + this.invoiceId + '/providers', 'An error occurred retrieving Providers.');
      } else if (Number(this.facilityId) > 0 && Number(this.invoiceWeeks.length) > 0 && this.invoiceStartDate) {
        data = [];
        for(const invoiceWeek of this.invoiceWeeks) {
          const startDate = (invoiceWeek as any).invoiceStartDate;
          const potentialUrl = `/invoices/providers?facilityId=${this.facilityId}&specialtyId=${(invoiceWeek as any).specialtyId}&invoiceDate=${startDate}`;
          const invoiceWeekProviderData = await (this as any).httpGet(potentialUrl, 'An error occurred retrieving Providers.');
          data.push(... invoiceWeekProviderData);
        }
      } else {
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'Invalid Invoice data. Unable to load Providers.'
        });
      }
      if (data) {
        this.providers = data;
      }
    },
    async addToQueue(providerId?: number) {
      const body = {invoiceId: this.invoiceId, providerId: providerId};
      const data = await (this as any).httpPost('/provider-payments/queue', 'An error occurred deleting Providers from Cart.', body, false);
      if (!data) {
        return;
      }
      this.$notify({
        group: 'main',
        type: 'success',
        title: 'Success',
        text: 'Inserted ' + data[0] + ' Providers to cart.'
      });
      await this.refresh();
    },
    async removeFromQueue(providerId?: number) {
      let url = '/provider-payments/queue?invoiceId=' + this.invoiceId;
      if (Number(providerId) > 0) {
        url += '&providerId=' + providerId;
      }
      const message = await (this as any).httpDelete(url, 'An error occurred deleting Providers from Cart.', false);
      if (!message) {
        return;
      }
      this.$notify({
        group: 'main',
        type: 'success',
        title: 'Success',
        text: message
      });
      await this.refresh();
    },
    async refresh() {
      await Promise.all([this.getProviders(), this.refreshProvidersToPayCount()]);
    },
    async refreshProvidersToPayCount() {
      InvoicesEventHub.$emit('PROVIDERS_TO_PAY_CHANGE');
    },
    browseToProvider (providerId: number) {
      window.open("/providers/" + providerId, '_blank');
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/invoices/components/Providers/InvoiceWeekProviders.ts